
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 200 200"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"fill",attrs:{"fill":"#141414","d":"M190.65 69.35l-.13-.19V52a20.35 20.35 0 00-20.35-20.35H29.83A20.35 20.35 0 009.48 52v17.16l-.13.19.13.08V148a20.35 20.35 0 0020.35 20.35h140.34A20.35 20.35 0 00190.52 148V69.43z"}}),_c('path',{staticClass:"fill filled",attrs:{"fill":"#fff","d":"M29.83 41.66h140.34A10.36 10.36 0 01180.52 52v12.19l-71.67 49.5a15.64 15.64 0 01-17.7 0l-71.67-49.5V52a10.36 10.36 0 0110.35-10.34z"}}),_c('path',{staticClass:"fill filled",attrs:{"fill":"#fff","d":"M180.52 148a10.36 10.36 0 01-10.35 10.35H29.83A10.36 10.36 0 0119.48 148V76.34l66 45.58a25.74 25.74 0 0029.08 0l66-45.58z"}})])
          )
        }
      }
    